import React from "react";

const SwBadge = ({
  variant = "info",   // success | warning | danger | info
  icon = null,        // pass JSX icon manually
  className = "",   // extra class name
  text = "",        // badge text
  ...rest
}) => {
  return (
    <div
      className={`SwBadge SwBadge-${variant} ${className}`}
      {...rest}
    >
      {icon && <span className="SwBadgeIcon">{icon}</span>}

      <span className="SwBadgeText">
        {text}
      </span>
    </div>
  );
};

export default SwBadge;